import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const TopDescription = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);
  const isDesktop = useIsDesktop();
  const mobileTextSX = {
    fontSize: '14px',
    lineHeight: '24px',
  };
  return (
    <Stack
      sx={{
        maxWidth: '700px',
        mb: '3rem',
        gap: '16px',
      }}
    >
      <Typography sx={isDesktop ? undefined : mobileTextSX}>
        {dictionary.topFirstDescription} {dictionary.topSecondDescription}
      </Typography>
      <Stack>
        <Typography
          sx={{
            fontWeight: 'bold',
          }}
        >
          {dictionary.topThirdTitle}
        </Typography>
        <Typography>{dictionary.topThirdDescription}</Typography>
      </Stack>
    </Stack>
  );
};
